var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSync(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "tk3rt08o4a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.592157 0 0 0 0 0.592157 0 0 0 0 0.592157 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#tk3rt08o4a)",
    transform: "translate(-816 -489)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M817.071 496.5a.536.536 0 0 1-1.071 0c0-4.136 3.364-7.5 7.5-7.5 2.061 0 3.969.821 5.357 2.236v-1.7a.536.536 0 0 1 1.072 0v3.214c0 .296-.24.536-.536.536h-3.214a.536.536 0 0 1 0-1.072h2.13a6.4 6.4 0 0 0-4.809-2.143 6.436 6.436 0 0 0-6.429 6.429zm13.393-.536a.536.536 0 0 0-.535.536 6.436 6.436 0 0 1-6.429 6.429 6.4 6.4 0 0 1-4.81-2.143h2.131a.536.536 0 0 0 0-1.072h-3.214a.536.536 0 0 0-.536.536v3.214a.536.536 0 0 0 1.072 0v-1.7A7.473 7.473 0 0 0 823.5 504c4.136 0 7.5-3.364 7.5-7.5a.536.536 0 0 0-.536-.536z",
    fill: "#000",
    fillRule: "nonzero"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSync);
export default __webpack_public_path__ + "static/media/sync.e5ab69ed2bd72471214fcefb87898d7d.svg";
export { ForwardRef as ReactComponent };